import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { FlatButton, PrimaryButton } from '../../../components/Buttons';
import { Popover } from '@material-ui/core';

const AboutPinLink = styled(FlatButton)`
  padding-left: 0px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
  color: ${(props) => props.theme.primaryColor};
  &:hover {
    transition: all 0.25s ease;
  }
`;

const PopoverTextWrapper = styled.div`
  width: 350px;
  padding: 20px;
  border-radius: 15px;
`;

const ConfirmButton = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  width: 100%;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const PopoverTitle = styled.div`
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 15px;
`;
const PopoverMessage = styled.div`
  margin-bottom: 15px;
`;
const EmailLink = styled.a`
  margin-left: 5px;
  color: #0b7fff;
`;

const AboutPin = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const handleAboutPin = useCallback((event) => {
    setAnchorEl(event?.currentTarget || null);
  }, []);

  return (
    <>
      <AboutPinLink
        onClick={(e) => {
          e.preventDefault();
          handleAboutPin(e);
        }}
      >
        About PIN
      </AboutPinLink>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleAboutPin()}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <PopoverTextWrapper>
          <PopoverTitle>GIFT CARD PIN</PopoverTitle>
          <PopoverMessage>
            Don't have your PIN? No problem! You can easily create a new digital
            card, or if you need help with an existing gift card, contact us at
            <EmailLink href='mailto:feedback@burritoboyz.ca'>
              feedback@burritoboyz.ca
            </EmailLink>
            . We're here to assist you!
          </PopoverMessage>
          <ConfirmButton onClick={() => handleAboutPin()}>Ok</ConfirmButton>
        </PopoverTextWrapper>
      </Popover>
    </>
  );
};

export default AboutPin;
